<template>
  <div class="flexRight" v-if="showingInfo">
    <div
      @scroll="onFilePostScroll"
      class="container is-fluid postContainer"
      :class="{ isWindow: isWindows }"
      id="filePostContainer"
    >
      <div class="topRight">
        <div class="cPic">
          <img
            class="rightSidePic"
            width="58"
            height="58"
            :src="
              curGroup.profileImage ? curGroup.profileImage : defaultGroupImage
            "
            alt="chat icon"
          />
          <!--
          <div v-if="!isMainSchoolGroup()">
            <vue-dropzone
              ref="profileDropZone"
              id="group-pic-right"
              :include-styling="false"
              :options="dropzoneOptions"
              @vdropzone-complete="setGroupImage"
            ></vue-dropzone>
          </div>
          -->
        </div>
        <div class="rightSideText">
          <div class="rightSideName">
            <b>{{ this.groupName }}</b>
          </div>
          <div v-if="groupType !== 'directMessages'">
            <button class="groupMembersButton" @click="fetchRankings()">
              {{ curGroup.users.length }} Members
              <img
                class="rightButtonArrow"
                :class="{ rightButtonArrowClicked: isShowingMembers }"
                src="@/assets/dropdown.png"
              />
            </button>
          </div>

          <div v-if="isShowingMembers">
            <div class="memberList" @click="addMembers">
              <div class="insideMember">
                <div class="listProfileImage">
                  <img
                    class="rightSidePic"
                    width="58"
                    height="58"
                    src="@/assets/groupAddImg.svg"
                  />
                </div>
                <p>Add Members</p>
              </div>
            </div>
            <div
              class="memberList"
              v-for="(member, index) in groupMembers"
              :key="index"
            >
              <div class="insideMember">
                <div class="listProfileImage" @click="routeChange(member.name)">
                  <img
                    class="rightSidePic"
                    width="58"
                    height="58"
                    :src="member.profileImage"
                  />
                </div>
                <div
                  class="flexCol"
                  @click="routeChange(member.name)"
                  style="cursor: pointer;"
                >
                  <p>{{ member.name }}</p>
                  <p v-if="isAdmin(member.user_id)" class="adminText">Admin</p>
                </div>
                <div
                  v-if="
                    isAdmin(user.id) &&
                      !isAdmin(member.user_id) &&
                      member.user_id != user.id
                  "
                  class="adminOptionsButton"
                  @click="toggleOptions(member)"
                >
                  <img height="25" width="25" src="@/assets/userOptions.svg" />
                </div>
              </div>
              <div v-if="userOptions == member" class="adminOptions">
                <div
                  class="adminOption"
                  style="  border-bottom: 1px solid #e0e0e0;"
                  @click="removeUser"
                >
                  Remove User
                </div>
                <div class="adminOption" @click="makeAdmin">Make Admin</div>
              </div>
              <div v-if="userOptions == member" class="optionsArrow"></div>
            </div>
          </div>

          <div>
            <button
              class="groupMembersButton"
              @click="isShowingPrivacy = !isShowingPrivacy"
            >
              Settings
              <img
                class="rightButtonArrow"
                :class="{ rightButtonArrowClicked: isShowingPrivacy }"
                src="@/assets/dropdown.png"
              />
            </button>
          </div>
          <div v-if="isShowingPrivacy">
            <div class="memberList" @click="muteChat">
              <div class="insideMember">
                <div class="listProfileImage listProfileImageGroupInfo">
                  <img
                    v-if="notificationsEnabled"
                    class="rightSidePic"
                    width="15"
                    height="15"
                    src="@/assets/chatBellIcon.svg"
                  />
                  <img
                    v-else
                    class="rightSidePic"
                    width="15"
                    height="15"
                    src="@/assets/chatNoBellIcon.svg"
                  />
                </div>
                <p v-if="notificationsEnabled">Mute Chat</p>
                <p v-else>Unmute Chat</p>
              </div>
            </div>
            <!--
            <div class="memberList" v-if="groupType !== 'directMessages'">
              <div class="insideMember">
                <div class="listProfileImage listProfileImageGroupInfo">
                  <img
                    class="rightSidePic"
                    width="15"
                    height="15"
                    src="@/assets/reportProblemIcon.svg"
                  />
                </div>
                <p>Report Problem</p>
              </div>
            </div>
            -->
            <div
              class="memberList"
              @click="leaveGroup"
              v-if="groupType !== 'directMessages'"
            >
              <div class="insideMember">
                <div class="listProfileImage listProfileImageGroupInfo">
                  <img
                    width="28"
                    height="25"
                    style="margin-left: 4px;"
                    src="@/assets/leaveGroupIcon.svg"
                  />
                </div>
                <p>Leave Group</p>
              </div>
            </div>
            <div class="memberList" @click="routeChange(curGroup.name)" v-else>
              <div class="insideMember">
                <div class="listProfileImage listProfileImageGroupInfo">
                  <img
                    class="rightSidePic"
                    width="15"
                    height="15"
                    src="@/assets/blockFriendIcon.svg"
                  />
                </div>
                <p>View Profile</p>
              </div>
            </div>
            <!--
            <div class="memberList" v-else>
              <div class="insideMember">
                <div class="listProfileImage listProfileImageGroupInfo">
                  <img
                    class="rightSidePic"
                    width="15"
                    height="15"
                    src="@/assets/removeFriendIcon.svg"
                  />
                </div>
                <p>Remove Friend</p>
              </div>
            </div>
            -->
            <div
              class="memberList"
              v-if="groupType !== 'directMessages'"
              @click="setImage"
            >
              <div class="insideMember">
                <div class="listProfileImage listProfileImageGroupInfo">
                  <img
                    height="25"
                    width="25"
                    src="@/assets/uploadImageIconGreen.svg"
                  />
                </div>
                <p>Edit Group Image</p>
              </div>
            </div>
          </div>

          <!--
          <div>
            <button
              class="groupMembersButton"
              @click="isShowingFiles = !isShowingFiles"
            >
              Documents
              <img
                class="rightButtonArrow"
                :class="{ rightButtonArrowClicked: isShowingFiles }"
                src="@/assets/dropdown.png"
              />
            </button>
          </div>
          -->
        </div>

        <div v-if="isShowingFiles" class="totalFile">
          <div
            class="fileBoard"
            v-for="(post, index) in filePosts"
            :key="index"
          >
            <FilePost
              :post="post"
              :index="index"
              :currentUser="user"
              @openGallery="openFilePostGallery"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilePost from "@/components/FilePost";
import db from "@/db";
import { mapState, mapActions } from "vuex";
//import vue2Dropzone from "vue2-dropzone";
//import "vue2-dropzone/dist/vue2Dropzone.min.css";
import firebase from "@/firebase";

export default {
  components: {
    //vueDropzone: vue2Dropzone,
    FilePost,
  },

  data: () => ({
    isWindows: false,
    isShowingMembers: false,
    isShowingFilters: false,
    isShowingFiles: false,
    isShowingPrivacy: false,
    notificationsEnabled: true,
    chatImage: "",
    groupMembers: [],
    filePosts: [],
    listeners: [],
    userOptions: "",

    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      maxFilesize: 5,
      maxFiles: 1,
      duplicateCheck: true,
      addRemoveLinks: true,
    },
  }),

  created() {
    this.notificationsEnabled = this.curGroup.notificationsEnabled
      ? this.curGroup.notificationsEnabled
      : true;
  },

  mounted() {
    //this.setGroupInfo();
    this.fetchFiles();
    this.isWindows = this.checkOS();
  },

  unmounted() {
    this.detachListeners();
    this.isShowingMembers = false;
    this.isShowingFilters = false;
    this.isShowingPrivacy = false;
    this.isShowingFiles = false;
  },

  computed: {
    ...mapState("messageBoard", [
      "groupId",
      "groupName",
      "groupType",
      "curGroup",
    ]),
    ...mapState("groupInfo", [
      "defaultGroupImage",
      "showingInfo",
      "addingMembers",
    ]),
    ...mapState("user", ["user"]),
  },

  methods: {
    ...mapActions("groupInfo", ["getGroupType"]),
    ...mapActions("messageBoard", ["detachListeners"]),
    ...mapActions("user", ["updateUserGroups"]),
    ...mapActions("messageBoard", ["unsubscribeFromTopic"]),

    toggleOptions(member) {
      this.userOptions = this.userOptions === member ? "" : member;
    },
    removeUser() {
      let index = this.curGroup.users.indexOf(this.userOptions);
      this.curGroup.users.splice(index, 1);
      this.groupMembers = this.curGroup.users;
      db.collection(this.curGroup.type)
        .doc(this.curGroup.id)
        .update({
          users: firebase.firestore.FieldValue.arrayRemove(this.userOptions),
        });
      this.$store.commit("messageBoard/setCurGroup", this.curGroup);
    },
    makeAdmin() {
      this.curGroup.admin.push(this.userOptions.user_id);
      db.collection(this.curGroup.type)
        .doc(this.curGroup.id)
        .update({
          admin: firebase.firestore.FieldValue.arrayUnion(
            this.userOptions.user_id
          ),
        });
      this.$store.commit("messageBoard/setCurGroup", this.curGroup);
    },
    isAdmin(id) {
      if (this.curGroup.admin) {
        return this.curGroup.admin.includes(id);
      }
      return false;
    },
    filterBy(type) {
      this.$emit("filterBy", type);
    },

    muteChat() {
      this.notificationsEnabled = !this.notificationsEnabled;
      this.curGroup.notificationsEnabled = this.notificationsEnabled;
      let index = this.user[this.curGroup.type].findIndex(
        (doc) => doc.id === this.curGroup.id
      );
      this.user[this.curGroup.type][
        index
      ].notificationsEnabled = this.curGroup.notificationsEnabled;
      this.$store.commit("messageBoard/setCurGroup", this.curGroup);
      this.updateUserGroups();
    },

    viewProfile() {
      let index = this.curGroup.users.findIndex(
        (x) => x.user_id !== this.user.id
      );
      var user = this.curGroup.users[index];
      this.$router.replace({
        name: "PublicProfile",
        params: { userName: user.name.replace(" ", "-") },
      });
    },

    leaveGroup() {
      if (this.groupType !== "directMessage") {
        let index = this.user[this.groupType].findIndex(
          (x) => x.id === this.groupId
        );
        this.user[this.groupType].splice(index, 1);
        this.$store.commit("user/setUser", this.user);
        var info = {
          name: this.user.firstName + " " + this.user.lastName,
          profileImage: this.user.profileImage,
          user_id: this.user.id,
        };
        db.collection(this.groupType)
          .doc(this.groupId)
          .update({
            users: firebase.firestore.FieldValue.arrayRemove(info),
            userCount: this.curGroup.users.length - 1,
          });
        if (this.user.iOSToken) {
          this.unsubscribeFromTopic({
            groupId: this.groupId,
            token: this.user.iOSToken,
          });
        }
        var joinedContent =
          this.user.firstName + " " + this.user.lastName + " left the group";
        this.addUserLeftGroupPost(joinedContent, this.curGroup);
        this.$store.commit("groupInfo/setShowingInfo", false);
        this.updateUserGroups();
        this.goToNextGroup();
      }
    },

    goToNextGroup() {
      if (this.user.allGroups.length > 0) {
        var nextGroup = this.user.allGroups[0];
        this.$store.commit("messageBoard/setGroupId", nextGroup.id);
        this.$store.commit("messageBoard/setGroupName", nextGroup.name);
        this.$store.commit("messageBoard/setGroupType", nextGroup.type);
        this.$store.commit("messageBoard/setCurGroup", nextGroup);
        this.$router.replace({
          name: "MessageBoard",
          params: { name: nextGroup.name, id: nextGroup.id, type: nextGroup.type },
        });
      }
    },

    addUserLeftGroupPost(content, group) {
      const id = "p" + db.collection("posts").doc().id;
      db.collection("posts")
        .doc(id)
        .set({
          content: content,
          chat_id: group.id,
          created_at: Date.now(),
        });
      group.recentPosts.push({
        content: content,
        id: id,
        created_at: Date.now(),
      });
      while (group.recentPosts.length > 25) {
        group.recentPosts.splice(0, 1);
      }

      db.collection(group.type)
        .doc(group.id)
        .update({
          recentPosts: group.recentPosts,
        });
    },

    routeChange(userName) {
      this.$router.replace({
        name: "PublicProfile",
        params: { userName: userName.replace(" ", "-") },
      });
    },

    addMembers() {
      this.$store.commit("groupInfo/setAddingMembers", true);
    },

    setImage() {
      this.$store.commit("messageBoard/setChangeImage", true);
    },

    updateGroupImage(image) {
      this.user.courses.forEach((course) => {
        if (course.id == this.groupId) {
          course.profileImage = image;
        }
      });

      this.user.faculties.forEach((faculty) => {
        if (faculty.id == this.groupId) {
          faculty.profileImage = image;
        }
      });
      this.user.groups.forEach((group) => {
        if (group.id == this.groupId) {
          group.profileImage = image;
        }
      });
    },

    async fetchFiles() {
      /*
      let ref = db
        .collection("posts")
        .where("chat_id", "==", this.groupId)
        .where("hasFiles", "==", true);
      let listener = ref
        .orderBy("created_at", "desc")
        .limit(10)
        .onSnapshot((posts) => {
          posts.docChanges().forEach((post) => {
            if (post.type === "added") {
              this.filePosts.push(post.doc.data());
            }

            if (post.type === "modified") {
              this.updateFilePost(post.doc.data());
            }
          });
        });
      await this.listeners.push(listener); // add listener to list
      */
    },

    updateFilePost(post) {
      for (const index in this.filePosts.length) {
        if (post.id === this.filePosts[index].id) {
          this.filePosts[index].deleted = true;
        }
      }
    },
    checkOS() {
      if (navigator.appVersion.indexOf("Win") != -1) {
        return true;
      }
      return false;
    },

    async fetchMoreFilePosts() {
      let listener = db
        .collection("posts")
        .where("chat_id", "==", this.groupId)
        .where("hasFiles", "==", true)
        .orderBy("created_at", "desc")
        .startAfter(this.filePosts[this.filePosts.length - 1].created_at)
        .limit(10)
        .onSnapshot((posts) => {
          posts.docChanges().forEach((post) => {
            if (post.type === "added") {
              this.filePosts.push(post.doc.data());
            }
          });
        });
      await this.listeners.push(listener);
    },

    /* Watches for scroll and calls fetchMoreFilePosts when scrolled to bottom */
    onFilePostScroll({ target: { scrollTop, scrollHeight, offsetHeight } }) {
      if (
        scrollHeight - offsetHeight - 100 < scrollTop &&
        this.filePosts.length >= 10
      ) {
        this.fetchMoreFilePosts(scrollTop);
      }
    },

    async setGroupImage(file) {
      var info = {
        group: this.groupId,
        user: this.user,
      };

      var groupType = await this.getGroupType(info);

      const storageRef = firebase.storage().ref();

      if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
        const fileRef = storageRef.child(
          `chatImage/${file.name}${Date.now()}.png`
        );

        await fileRef.put(file); //puts file in firbase storage
        const downloadURL = await fileRef.getDownloadURL(); //gets file url from firebase storage

        this.chatImage = downloadURL; //sets new profile pic
        this.$refs.profileDropZone.removeAllFiles(true); //removes file from dropzone

        await db
          .collection(groupType)
          .doc(this.groupId)
          .update({
            profileImage: downloadURL,
          });
      }
    },

    openFilePostGallery(index, files) {
      let selectedImage = files[index];
      var count = 0;
      var selectedIndex; //the index of the image that was clicked
      var media = []; //the files that will be displayed

      //Iterates through all file posts and adds
      for (const post in this.filePosts) {
        for (const file in this.filePosts[post].files) {
          if (selectedImage.src == this.filePosts[post].files[file].src) {
            selectedIndex = count;
          }
          const fi = {
            thumb: this.filePosts[post].files[file].src,
            src: this.filePosts[post].files[file].src,
          };
          count += 1;
          media.push(fi);
        }
      }
      this.$emit("openFilePostGallery", media, selectedIndex);
    },

    fetchRankings() {
      this.groupMembers = [];
      this.curGroup.admin.forEach((userId) => {
        let index = this.curGroup.users.findIndex((x) => x.user_id === userId);
        if (index !== -1) {
          this.groupMembers.push(this.curGroup.users[index]);
        }
      });
      var sortMembers = this.curGroup.users.filter(
        (x) => this.groupMembers.indexOf(x) === -1
      );
      sortMembers.sort((a, b) => a.name.localeCompare(b.name));
      this.groupMembers.push(...sortMembers);
      this.isShowingMembers = !this.isShowingMembers;
    },

    getGroupArrayType() {
      for (const index in this.user.courses) {
        if (this.user.courses[index].id === this.groupId) {
          return "course_ids";
        }
      }
      for (const index in this.user.faculties) {
        if (this.user.faculties[index].id === this.groupId) {
          return "faculty_ids";
        }
      }

      for (const index in this.user.directMessages) {
        if (this.user.directMessages[index].id === this.groupId) {
          return "dm_ids";
        }
      }

      return "group_ids";
    },

    detachListeners() {
      this.listeners.forEach((listener) => listener());
      this.listeners = [];
    },

    isMainSchoolGroup(groupId) {
      return (
        groupId == "NcZfa5GYSOPCWk3J6v6g" || groupId == "5TkXyZj0W2zyFpgQRrNJ"
      );
    },
  },
};
</script>

<style scoped>
#filePostContainer {
  overflow-y: hidden;
}
#filePostContainer:hover {
  overflow-y: overlay;
}
.listProfileImageGroupInfo {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
